<template>
    <div>
        <b-row>
            <b-col sm="5" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input
                                @keydown.enter.native="search()"
                                placeholder="Search"
                                v-model="searchString">
                        </b-form-input>
                        <b-dropdown :no-flip="true" text="Advanced" variant="primary" slot="append">
                            <!--<b-dropdown-item></b-dropdown-item>-->
                            <!--<div class="ml-3 p-1" id="search-checkbox">
                                <b-form-checkbox-group
                                        stacked
                                        v-model="selectedSearchOption"
                                        name="searchOptions"
                                        :options="searchableFields" class="checkbox-group">
                                </b-form-checkbox-group>
                            </div>-->
                            <b-dropdown-item v-for="searchField in searchableFields"
                                             :key="searchField.value"
                                             @click="searchOption(searchField.value)">
                                {{ searchField.text }}
                                <i v-if="selectedSearchOption.indexOf(searchField.value) !== -1" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                </i>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-input-group>
                </div>
            </b-col>
            <b-col sm="5" md="9" class="text-left text-md-right">
                <b-button ref="refNewTargetSegment" :to="{path: '/customers/target-segment/create'}"
                    variant="primary new-button">
                    + New Target Segment
                </b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table :items="targetSegments"
                         :fields="fields"
                         ref="refTargetSegments"
                         show-empty
                         id="my-table"
                         :empty-text="(loading) ? 'Loading data' : 'No target segment records found'"
                         responsive>
                    <template slot="name" slot-scope="data">
                        <router-link :to="{path: '/customers/target-segment/edit'}">
                            <a href="#" @click="attemptEdit(data.item.target_segment_uuid)" id="myButton" class="foo bar">{{data.value}} </a>
                        </router-link>
                    </template>
                    <template slot="visibility" slot-scope="data">
                        <!--changed @click.native="visibility(data.value, data.index)"-->
                        <switches
                            v-model="data.value"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            text-enabled="On"
                            text-disabled="Off">
                        </switches>
                    </template>
                    <template slot="target_segment_uuid" slot-scope="data">
                        <b-button :to="{path: '/customers/target-segment/edit'}" @click="attemptEdit(data.value)"
                                  variant="ghost btn-table-edit">
                        </b-button>
                        <b-button
                                @click="attemptDelete(data.value)"
                                variant="ghost btn-table-delete"
                                v-b-modal="'delete-target'">
                        </b-button>
                    </template>
                    <template slot="customer_count" slot-scope="data">
                        {{ data.value == null ? "..." : data.value }}
                    </template>
                </b-table>
            </div>
            <div>
                <b-row>
                    <b-col>
                        <div>
                            <span class="pagination-indicator">{{ currentFirstItem }}-{{ currentLastItem }} of {{ maxPage}} pages</span>
                            <b-pagination
                                hide-goto-end-buttons
                                align="left" 
                                size="md"
                                :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                                :limit="(totalPerPage > 0 ) ? 3 : 1"
                                :per-page="totalPerPage"
                                @change="paginate"
                                class="custom-pagination-arrow-only">
                            </b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal @ok="handleDelete()"
                 id="delete-target"
                 title="Delete Target Segment"
                 centered>
            <p class="text-center">Are you sure you want to delete this target segment?</p>
        </b-modal>
    </div>
</template>

<script>
import Switches from "vue-switches";
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "TargetSegments",
    components: {
        Switches
    },
    data() {
        return {
            fields: [
                {
                    key: "name",
                    sortable: true
                },
                {
                    key: "description",
                    sortable: true
                },
                {
                    key: "customer_count",
                    sortable: true
                },
                {
                    key: "visibility",
                    sortable: false
                },
                {
                    key: "target_segment_uuid",
                    sortable: false,
                    variant: "action",
                    label: "Action"
                }
            ],
            toDelete: null,
            toEdit: null,
            selectedSearchOption: [],
            searchString: "",
            searchPayload: null,
            env: process.env.VUE_APP_MODE
        };
    },
    computed: {
        ...mapState("customerTargetSegment", [
            "targetSegments",
            "maxPage",
            "nextPage",
            "prevPage",
            "currentPage",
            "totalPerPage",
            "currentFirstItem",
            "currentLastItem",
            "initialPageCount",
            "searchableFields",
            "defaultSelectedSearchOption",
            "errors",
            "form",
            "loading"
        ])
    },
    created() {
        this.getTargetSegments(1);
        this.getSearchOptions();
    },
    methods: {
        getTargetSegments(page) {
            let param = {
                page: page,
                payload: {
                    search: this.searchPayload
                }
            };

            this.$store.dispatch(
                "customerTargetSegment/getTargetSegments",
                param
            );
        },
        search() {
            let searchPayload = [];
            let _this = this;

            if (this.selectedSearchOption.length === 0) {
                this.selectedSearchOption.push(
                    this.defaultSelectedSearchOption
                );
            }
            _.forEach(_this.selectedSearchOption, function(field) {
                let obj = {};
                obj[field] = _this.searchString.trim();
                searchPayload.push(obj);
            });
            this.searchPayload = searchPayload;

            this.getTargetSegments(1);
        },
        async getSearchOptions() {
            await this.$store.dispatch(
                "customerTargetSegment/getSearchableFields"
            );
            this.selectedSearchOption.push(this.defaultSelectedSearchOption);
        },
        visibility(value, index) {
            let param = {
                apiFields: {
                    visibility: !value
                },
                uuid: this.targetSegments[index].target_segment_uuid,
                index: index
            };

            this.$store.dispatch("customerTargetSegment/visibility", param);
        },
        attemptDelete(uuid) {
            this.toDelete = uuid;
        },
        async attemptEdit(uuid) {
            console.log(uuid);
            await this.$store.commit(
                "customerTargetSegment/activeTSUuid",
                uuid
            );
        },
        handleDelete() {
            this.$store.dispatch("customerTargetSegment/delete", this.toDelete);
        },
        searchOption(value) {
            this.selectedSearchOption = [value];
            if (this.searchString.trim() !== "") {
                this.search();
            }
        },
        paginate(page) {
            // if (this.searching) {
            //     return this.search(false, page);
            // }
            return this.getTargetSegments(page);
        },
    }
};
</script>
<style lang="scss">
</style>
